import productHighlight from '../components/homeProduct.svelte'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

let tl = gsap.timeline()

export default {
	init() {
		let $homeProductHighlight = $('#productHighlight')
		if ($homeProductHighlight.length) {
			new productHighlight({
				target: $homeProductHighlight[0],
				props: $homeProductHighlight.data(),
			})

			tl.fromTo(
				'#productHighlight .home-product-highlight-right',
				{
					opacity: 0,
					x: 50,
				},
				{
					scrollTrigger: {
						trigger: '#productHighlight',
						// toggleActions: 'restart pause restart none', // onEnter, onLeave, onEnterBack, and onLeaveBack
					},
					duration: 0.5,
					delay: 0.25,
					opacity: 1,
					x: 0,
				}
			)
			document.querySelectorAll('.home-product-image-badge').forEach((item) => {
				tl.fromTo(
					item,
					{ y: 15, opacity: 0 },
					{
						scrollTrigger: item,
						delay: 0,
						duration: 0.25,
						y: 0,
						opacity: 1,
					}
				)
			})
			gsap.fromTo(
				'.home-product-highlight-left',
				{
					opacity: 0,
					x: -50,
				},
				{
					scrollTrigger: {
						trigger: '#productHighlight',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.2,
					opacity: 1,
					x: 0,
				}
			)
		}

		const $homeSliderWrap = $('#homeSliderWrap')
		if ($homeSliderWrap.length) {
			tns({
				container: '#homeSliderWrap',
				items: 1,
				slideBy: 1,
				autoplay: true,
				nav: true, //dots
				controls: false, //arrows
				touch: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,
				speed: 750,
				controlsText: [
					'<span class="sr-only">prev</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M11 26l21 21-5 5L2 28l-2-2 2-3L27 0l5 5-20 18"/></svg>',
					'<span class="sr-only">Next</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M21 26L0 47l5 5 25-24 2-2-2-3L5 0 0 5l20 18"/></svg>',
				],
				responsive: {
					767: {
						nav: false, //dots
						controls: true, //arrows
					},
				},
			})

			gsap.fromTo(
				'#homeSliderWrap .home-slide-image',
				{
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '#homeSliderWrap',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.25,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#homeSliderWrap .home-slide-content',
				{
					x: -50,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '#homeSliderWrap',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}

		let $homeCta = $('#homeCta')
		if ($homeCta.length) {
			gsap.fromTo(
				'#homeCta .home-cta-left',
				{
					x: -50,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '#homeCta',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.5,
					x: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#homeCta .home-cta-right',
				{
					x: 50,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '#homeCta',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.5,
					x: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#homeCta .home-cta-inner',
				{
					y: -50,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '#homeCta',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					delay: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
